module.exports = __webpack_public_path__ + "static/img/06004B_4_5_C_20240604_fit.743a134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/06004B_4_5_C_20240604_fit.png
// module id = 2EH4
// module chunks = 0